'use client'

import { createContext, useContext, useMemo } from 'react'

import type { UserNavigation, UserSession } from '@/types/user'

type PlatformProviderProps = {
  children: React.ReactNode
  initialData: {
    hasMaestroViewAccess: boolean
    userSession: UserSession
    userNavigation: UserNavigation[]
  }
}

type PlatformContextType = {
  hasMaestroViewAccess: boolean
  userSession: UserSession
  userNavigation: UserNavigation[]
}

const PlatformContext = createContext<PlatformContextType | undefined>(undefined)

const PlatformProvider: React.FC<PlatformProviderProps> = (props) => {
  const { children, initialData } = props

  const value = useMemo(() => {
    return {
      hasMaestroViewAccess: initialData.hasMaestroViewAccess,
      userSession: initialData.userSession,
      userNavigation: initialData.userNavigation,
    }
  }, [
    initialData.hasMaestroViewAccess,
    initialData.userSession,
    initialData.userNavigation,
  ])

  return <PlatformContext.Provider value={value}>{children}</PlatformContext.Provider>
}

const usePlatform = () => {
  const context = useContext(PlatformContext)
  if (!context) {
    throw new Error('usePlatform must be used within a PlatformProvider')
  }
  return context
}

export { usePlatform }

export default PlatformProvider
